import('./bootstrap').catch((err: unknown) => console.error(err));
import { isDevMode } from '@angular/core';
import * as Sentry from '@sentry/angular';

const env = isDevMode() ? 'dev' : 'production';
Sentry.init({
  dsn: 'https://800dfb561734b6b5561b308c27489fff@sen.tim-schatz.de/2',
  integrations: [
    // Registers and configures the Tracing integration,
    // which automatically instruments your application to monitor its
    // performance, including custom Angular routing instrumentation
    Sentry.browserTracingIntegration(),
    // Die Sitzungsaufzeichnung steht bewusst nicht hier, sondern wird unten nachgeladen.
    // Sie macht rund 125 kB aus und laege sonst in main.js, also in der Datei, die der
    // Browser abarbeiten muss, bevor ueberhaupt etwas zu sehen ist.
  ],
  environment: env,

  // Fehler, die nicht aus dieser Anwendung stammen, sondern aus dem, was drumherum im
  // Browser laeuft. Nachgesehen: die Stapelabbildungen zeigen ausschliesslich auf fremde
  // Bruecken und [native code], nie auf eigene Dateien.
  //
  // Bewusst NICHT hier stehen Meldungen, die zwar nach Browser klingen, aber aus eigenem
  // Verhalten entstehen. "Attempt to use history.replaceState() more than 100 times" etwa
  // kommt aus resetUrlToCurrentUrlTree des Angular-Routers, also aus einer Navigations-
  // schleife von uns. So etwas gehoert behoben und nicht stummgeschaltet.
  ignoreErrors: [
    // Android-WebView: die Bruecke zwischen Javascript und der umgebenden App.
    /Error invoking \w+: Java/,
    // Autofill-Bruecke eines In-App-Browsers.
    'xbrowser',
    // Leseansicht von Firefox auf iOS.
    '__firefox__',
    // Browser-Erweiterung, die mit ihrem eigenen Hintergrundskript spricht.
    'runtime.sendMessage',
  ],

  // Jede fuenfte Seite reicht, um p50 und p95 zu bestimmen. Bei 1.0 kam von jedem
  // Zuschauer der oeffentlichen Programmseite eine eigene Messung, das waren allein
  // ueber ein Regattawochenende zehntausende.
  tracesSampleRate: 0.2,

  // Set `tracePropagationTargets` to control for which URLs trace propagation should be enabled
  tracePropagationTargets: ['localhost', /^https:\/\/app\.regatto\.de\/api/, /^https:\/\/ved\.regatto\.de\/api/],

  // Jede zehnte Sitzung wird aufgezeichnet, jede Sitzung mit einem Fehler vollstaendig.
  // Der interessante Fall ist die Sitzung mit Fehler, und die faengt die zweite Zahl.
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
});

// Nach der Initialisierung und ausserhalb von main.js, siehe sentry-replay.ts.
// Scheitert das Nachladen, laeuft die Anwendung ohne Aufzeichnung weiter.
void import('./app/custom/shared/sentry/sentry-replay').then(modul => modul.replayAktivieren()).catch(() => undefined);
